import { useEffect } from 'react';
import { pollIntervalMs, pollTimeoutMs } from './playgroundConfig';

// Polls onTick while active, and calls onTimeout once the wallet has stayed silent
// for too long. Both callbacks are read through a ref-free dependency list on
// purpose: pass stable callbacks or accept a restart when they change.
export const usePolling = (active: boolean, onTick: () => void, onTimeout: () => void) => {
    useEffect(() => {
        if (!active) {
            return;
        }
        const interval = setInterval(onTick, pollIntervalMs);
        const timeout = setTimeout(onTimeout, pollTimeoutMs);
        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active]);
};
